{
  "2026.08.04-fruit-seller-chased": [
    1280,
    720
  ],
  "2026.08.20-human-safari-bus-attack": [
    904,
    1205
  ],
  "Andrushenko, FPV drone": [
    2252,
    1501
  ],
  "Andrushenko, human safari": [
    2814,
    1876
  ]
}
